import React, { useState } from "react";
import { Checkbox, Spin } from "antd";
import { useTranslation } from "react-i18next";

const Step1 = (props) => {

  
  const [selectAll, setSelectAll] = useState(false);
  const {bookDetails, loading, setSelectedSubLessons, selectedSubLessons,selectChapter, setSelectChapter} = props;
  const handleChapterSelect = (chapter, subChapters) => {
    setSelectChapter((prevSelected) =>
      prevSelected.includes(chapter)
        ? prevSelected.filter((ch) => ch !== chapter)
        : [...prevSelected, chapter]
    );

    if (!selectChapter.includes(chapter)) {
      setSelectedSubLessons((prevSelected) => [
        ...prevSelected,
        ...subChapters.map(sub => sub.title).filter((lesson) => !prevSelected.includes(lesson)),
      ]);
    } else {
      setSelectedSubLessons((prevSelected) =>
        prevSelected.filter((lesson) => !subChapters.map(sub => sub.title).includes(lesson))
      );
    }
  };
  const { t, i18n } = useTranslation();
  const handleSubLessonSelect = (subLesson, chapterTitle) => {
    setSelectedSubLessons((prevSelected) =>
      prevSelected.includes(subLesson)
        ? prevSelected.filter((sl) => sl !== subLesson)
        : [...prevSelected, subLesson]
    );

    if (!selectChapter.includes(chapterTitle)) {
      setSelectChapter((prevSelected) => [...prevSelected, chapterTitle]);
    }
  };

  const handleSelectAll = (e) => {
    setSelectAll(e.target.checked);
    if (e.target.checked && bookDetails) {
      setSelectChapter(bookDetails.chapters.map((item) => item.title));
      setSelectedSubLessons(bookDetails.chapters.flatMap((item) => 
        item.subChapters.map(sub => sub.title)
      ));
    } else {
      setSelectChapter([]);
      setSelectedSubLessons([]);
    }
  };

  if (loading || !bookDetails) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
        <Spin size="large" />
      </div>
    );
  }

  return <>
    <Checkbox onChange={handleSelectAll} checked={selectAll}>
      <h4 className="fs-5 fw-bold"> {t("SelectAllChapters")}</h4>
    </Checkbox>
    <div className="row g-3 mt-3">
      {bookDetails.chapters.map((item, index) => (
        <div className="col-md-6" key={index}>
          <div className="card examDataWrapper">
            <div className="card-body">
              <Checkbox
                onChange={() => handleChapterSelect(item.title, item.subChapters)}
                checked={selectChapter.includes(item.title)}
              >
                <h5 className="card-title text-white">{index + 1}. {item.title}</h5>
              </Checkbox>
              <ul>
                {item.subChapters.map((subChapter, idx) => (
                  <li key={idx}>
                    <Checkbox
                      onChange={() => handleSubLessonSelect(subChapter.title, item.title)}
                      checked={selectedSubLessons.includes(subChapter.title)}
                    >
                      <p className="text-white">{subChapter.title}</p>
                    </Checkbox>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      ))}
    </div>
  </>;
};

export default Step1;
